import { styled } from '@mui/material';
import { Colors } from 'library';
import DefaultProfileImage from 'assets/icons/Profile.svg';

export const CardWrapper = styled('div')(({ showcase }: { showcase: boolean }) => ({
    position: 'relative' as const,
    borderRadius: 12,
    padding: '16px 20px',
    marginBottom: 12,
    maxWidth: 700,
    backgroundColor: showcase ? '#FAF0ED' : Colors.white,
    borderLeft: showcase ? `4px solid ${Colors.terraCotta}` : 'none',
    boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.06), 0px 2px 8px rgba(0, 0, 0, 0.04)',
    transition: 'box-shadow 0.15s ease',
    '&:hover': {
        boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.08), 0px 4px 12px rgba(0, 0, 0, 0.06)',
    },
}));

export const TopRightAction = styled('div')({
    position: 'absolute',
    top: 12,
    right: 12,
    zIndex: 1,
});

export const CardTopRow = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 14,
});

export const MobileTopRow = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 10,
});

export const MobileContent = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    marginTop: 10,
});

export const MobileBottomRow = styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 4,
});

export const CheckboxContainer = styled('div')({
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    marginLeft: 'auto',
});

export const AvatarContainer = styled('div')({
    flexShrink: 0,
});

export const StyledProfileImage = styled(DefaultProfileImage)({
    height: 44,
    width: 44,
    borderRadius: '50%',
    flexShrink: 0,
});

export const InfoContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0,
    gap: 3,
});

export const NameRow = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    flexWrap: 'wrap',
});

export const ShowcaseBadge = styled('div')({
    backgroundColor: Colors.terraCotta,
    borderRadius: 4,
    padding: '2px 8px',
});

export const CredentialLine = styled('div')({
    display: 'flex',
    alignItems: 'baseline',
    flexWrap: 'wrap',
});

export const TagsRow = styled('div')({
    display: 'flex',
    gap: 8,
    flexWrap: 'wrap',
    marginTop: 4,
});

export const RightSection = styled('div')({
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    gap: 8,
});

export const RatingRow = styled('div')({
    display: 'flex',
    alignItems: 'center',
});

export const BioSection = styled('div')({
    padding: '12px 0 4px 0',
});

export const BioDivider = styled('hr')({
    border: 'none',
    borderTop: `1px solid ${Colors.lightGrey}`,
    margin: '0 0 12px 0',
});
